import { useEffect, useState } from "react";
import { cloudflare } from "@/integrations/cloudflare/client";
import type { ProjectProfile } from "@/types/project";

interface ProjectDetailsHeaderProps {
  currentProject?: ProjectProfile;
  currentProjectId?: string;
}

export function ProjectDetailsHeader({
  currentProject,
  currentProjectId,
}: ProjectDetailsHeaderProps) {
  const [projectData, setProjectData] = useState<ProjectProfile | undefined>(currentProject);

  useEffect(() => {
    if (currentProjectId && !currentProject) {
      // Fetch project data from database
      const fetchProject = async () => {
        const { data, error } = await cloudflare
          .from("projects")
          .select("*")
          .eq("id", currentProjectId)
          .single();

        if (data && !error) {
          setProjectData({
            customerName: data.customer_name,
            email: data.email,
            phone: data.phone,
            address: data.address,
            city: data.city,
            budget: data.budget,
            timeframe: data.timeframe,
            description: data.description,
          });
        }
      };
      fetchProject();
    } else if (currentProject) {
      setProjectData(currentProject);
    }
  }, [currentProjectId, currentProject]);

  return (
    <div className="bg-card rounded-lg p-6 border mb-6">
      <h2 className="text-lg font-semibold text-foreground mb-4">Project Details</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <p className="text-sm text-muted-foreground">Customer</p>
          <p className="font-medium text-foreground">{projectData?.customerName || "N/A"}</p>
        </div>
        <div>
          <p className="text-sm text-muted-foreground">Address</p>
          <p className="font-medium text-foreground">{projectData?.address || "N/A"}</p>
        </div>
        <div>
          <p className="text-sm text-muted-foreground">Budget</p>
          <p className="font-medium text-foreground">{projectData?.budget || "N/A"}</p>
        </div>
      </div>
      {projectData?.description && (
        <div className="mt-4 pt-4 border-t">
          <p className="text-sm text-muted-foreground mb-1">Description</p>
          <p className="font-medium text-foreground">{projectData.description}</p>
        </div>
      )}
    </div>
  );
}
